import business from './../images/logos/Business.com_Logo.svg';
import equities from './../images/logos/equities.png';
import forbes from './../images/logos/forbes.svg';
//import huffpost from './../images/logos/huffpost-2.png';
import patch from './../images/logos/patch.svg';
import inman from './../images/logos/inman-logo.svg';
import pix from './../images/logos/pix.png';
// import wsj from './../images/logos/wsj-logo.png';
import WTSP from './../images/logos/wtsp.png';

const brands= [
    {
        img: business
    },
    {
        img: forbes
    },
    {
        img: inman
    },
    {
        img:pix
    },
    {
        img:equities
    },
    {
        img:WTSP
    },
    {
        img:patch
    }
]

export default brands;




